import { useCallback, useEffect, useState } from "react";
import { getPosition } from "../../services/userManagement";

const usePositionStaff = () => {
  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    const res = await getPosition();
    if (res.data.code === "0000") {
      const { objectValue } = res.data;
      setData(objectValue);
    }
  }, [setData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return [data];
};

export default usePositionStaff;
